// @flow
'use strict'

const mapKeys_ = require('lodash/mapKeys')
const startsWith_ = require('lodash/startsWith')
const assign_ = require('lodash/assign')
const get_ = require('lodash/get')
const maybe = require('folktale/maybe')

const { FIELD_TYPES } = require('dbsm-common/src/collections/consts')

/*::
import type { ConnectionConfig } from '../viewer-app-module/platformTypes'
import type { GetFieldType } from '../schemas/types'

type DynamicPropertiesResolver = (
  { connectionConfig: ConnectionConfig },
  role: string,
  getFieldType: GetFieldType
) => ConnectionConfig
*/

const dynamicPropertiesHandlers = {
  $text: fieldType => (fieldType === FIELD_TYPES.RICHTEXT ? 'html' : 'text')
}

const resolveDynamicProperty = (propName, propertyConfig, getFieldType) =>
  maybe
    .fromNullable(dynamicPropertiesHandlers[propName])
    .map(propHandler => {
      const fieldType = getFieldType(propertyConfig.fieldName)
      return propHandler(fieldType)
    })
    .getOrElse(propName)

const resolveDynamicProperties /*: DynamicPropertiesResolver */ = (
  { connectionConfig },
  role,
  getFieldType
) =>
  maybe
    .fromNullable(get_(connectionConfig, 'properties'))
    .map(properties =>
      mapKeys_(
        connectionConfig.properties,
        (property, propName) =>
          startsWith_(propName, '$')
            ? resolveDynamicProperty(propName, property, getFieldType)
            : propName
      )
    )
    .map(properties => assign_({}, connectionConfig, { properties }))
    .getOrElse(connectionConfig)

exports.resolveDynamicProperties = resolveDynamicProperties



// WEBPACK FOOTER //
// ./components/dynamicProperties.js